import {Component, Input} from "@angular/core";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {ImportExcelService, TypeLogImportExcel} from '@shared/services/global';


@Component({
  standalone: false,
  selector: 'app-import-excel-common-log',
  templateUrl: 'import-excel-modal.component.html',
})
export class ImportExcelNewModalComponent {
  @Input() service!: ImportExcelService;
  @Input() useOnlyContent = false;

  activeTab: TypeLogImportExcel = 'all';

  constructor(
    public activeModal: NgbActiveModal,
  ) {

  }
}
